import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { ArrowUpRightIcon } from '@phosphor-icons/react';
import { PillButton } from '@/components/kit';
import { useBookingNav } from '@/features/booking/useBookingNav';
import { useAssistantNav } from '@/features/assistant/useAssistantNav';
import { useStudio } from './studio-data';

/**
 * «Записаться» pinned above the bottom navigation. On the home page it appears once
 * the photo with its own button has scrolled away; on the services page it is always
 * there. It hides while a sheet is open or the keyboard is up.
 */
export function StickyBook() {
  const studio = useStudio();
  const booking = useBookingNav();
  const assistant = useAssistantNav();
  const { pathname } = useLocation();
  const base = `/s/${studio.slug}`;
  const onHome = pathname === `${base}/` || pathname === base;
  const onServices = pathname.startsWith(`${base}/services`);
  const [heroVisible, setHeroVisible] = useState(true);

  useEffect(() => {
    if (!onHome) return;
    const hero = document.querySelector('[data-testid="hero-book"]');
    if (!hero || !('IntersectionObserver' in window)) {
      setHeroVisible(false);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => setHeroVisible(Boolean(entry?.isIntersecting)), {
      threshold: 0.2,
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, [onHome, pathname]);

  const visible = (onServices || (onHome && !heroVisible)) && !booking.step && !assistant.isOpen;

  useEffect(() => {
    const root = document.documentElement;
    if (onHome || onServices) root.dataset.stickyCta = 'on';
    else delete root.dataset.stickyCta;
    return () => {
      delete root.dataset.stickyCta;
    };
  }, [onHome, onServices]);

  if (!onHome && !onServices) return null;
  return (
    <div className="ui-sticky-cta" data-visible={visible} aria-hidden={!visible}>
      <PillButton
        variant="primary"
        size="lg"
        block
        endIcon={ArrowUpRightIcon}
        tabIndex={visible ? 0 : -1}
        onClick={() => booking.open()}
        data-testid="sticky-book"
      >
        Записаться
      </PillButton>
    </div>
  );
}
